import React from "react"
import { EventObjectDto } from "../../../state/event/Event"
import { InvoiceDto } from "../../../state/invoice/models"
import { FormattedMessage } from "react-intl"
import { Proposal } from "../../../state/proposal/models"
import Integrations from "../../../integration/Integrations"

const IntegrationKey = "mailchimp"
type OwnProps = {
    object: EventObjectDto
    invoice: InvoiceDto
    proposal: Proposal
}

const InvoiceExportedToMailchimpEvent = (props: OwnProps) => {
    const type = props.object.attributes.entityType
    const Url = ""

    const renderMessage = () => {
        switch (type) {
        case "main":
            return <FormattedMessage
                id="invoice.analytics.events.invoice_exported.square.text"
                defaultMessage="Invoice {identifier} has been exported to Mailchimp"
                values={{
                    identifier: <strong>{props.invoice.attributes.identifier}</strong>,
                }}
            />
        case "void":
            return <FormattedMessage
                id="invoice.analytics.events.exported.mailchimp.void_text"
                defaultMessage="Invoice {identifier} has been deleted in Mailchimp"
                values={{
                    identifier: <strong>{props.invoice.attributes.identifier}</strong>,
                }}
            />
        case "invoice-adjustment":
            return <></>
        case "payment-adjustment":
            return <></>
        case "inventory-adjustment":
            return <></>
        default:
            return <></>
        }
    }

    return (
        <div className={"row"}>
            <div className={"col-12"}>
                <p className={"mb-2"}>
                    {renderMessage()}
                </p>
            </div>

            <div className={"col-12 d-flex align-items-center flex-wrap"}>
                <div className={"mr-3"}>
                    <a href={Url} target="_blank" rel="noreferrer">
                        {Integrations.getIntegrationLogoImage(IntegrationKey, 150)}
                    </a>
                </div>
                {Url &&
                    <div className={""}>
                        <p className={"mb-0"}>
                            <a href={Url} target={"_blank"} className={"btn btn-sm btn-outline-primary"}
                                rel="noreferrer">
                                <FormattedMessage
                                    id="invoice.analytics.events.exported.mailchimp.open"
                                    defaultMessage="Open order in Mailchimp"
                                />
                            </a>
                        </p>
                    </div>
                }
            </div>
        </div>
    )
}

export default InvoiceExportedToMailchimpEvent




// WEBPACK FOOTER //
// ./src/quote/analytics/events/invoice-exported-mailchimp.component.tsx